import { render, staticRenderFns } from "./Socio.vue?vue&type=template&id=aa6d4d7c&scoped=true"
import script from "./Socio.vue?vue&type=script&lang=js"
export * from "./Socio.vue?vue&type=script&lang=js"
import style0 from "./Socio.vue?vue&type=style&index=0&id=aa6d4d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6d4d7c",
  null
  
)

export default component.exports